/* eslint-disable no-console */

import { register } from "register-service-worker";

// const baseUrl = 'http://localhost'
// const baseUrl = 'https://veki.pl'
const baseUrl = "https://devveki.ctit.pl"

// if (process.env.NODE_ENV === "production") {
  register(`${baseUrl}/wp-content/themes/veki-wp/compiled/service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updated() {
      console.log("New content is available; please refresh.");
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
// }
